import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import { API_BASE_URL } from "../api";

export default function ForgotPasswordPage({ navigate, user, onLogin, onAccount, showBlog = true, onShareSite }) {
  useEffect(() => {
    document.title = "СоцПлан | Восстановление доступа";
  }, []);

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const submit = async (event) => {
    event.preventDefault();
    setError("");
    if (!emailRegex.test(email.trim())) {
      setError("Введите корректный e-mail");
      return;
    }
    setLoading(true);
    try {
      await fetch(API_BASE_URL + "/auth/password/forgot", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim() }),
      });
    } catch (err) {
      console.error("[Forgot password]", err);
      setError("Не удалось отправить запрос. Попробуйте ещё раз");
      setLoading(false);
      return;
    }
    setLoading(false);
    navigate("forgotPasswordSent");
  };

  return (
    <div className="min-h-screen bg-slate-100 py-6 md:py-10">
      <div className="mx-auto w-full max-w-3xl rounded-2xl border bg-white shadow-md">
        <Header
          navigate={navigate}
          user={user}
          onLogin={onLogin}
          onAccount={onAccount}
          showBlog={showBlog}
          onShareSite={onShareSite}
        />
        <section className="px-5 md:px-6 py-8">
          <h1 className="text-2xl font-semibold">Восстановление доступа</h1>
          <p className="mt-3 text-slate-600">
            Укажите e-mail, который вы использовали при регистрации. Мы отправим ссылку для сброса пароля, если такой аккаунт существует.
          </p>
          <form onSubmit={submit} className="mt-6 max-w-xl space-y-4">
            <label className="block text-sm font-medium text-slate-700" htmlFor="forgot-email">
              E-mail
            </label>
            <input
              id="forgot-email"
              type="email"
              autoComplete="email"
              className="w-full rounded-lg border px-3 py-2 text-[15px] focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={email}
              onChange={(event) => {
                setEmail(event.target.value);
                setError("");
              }}
              placeholder="you@example.com"
            />
            {error && <div className="text-sm text-red-600">{error}</div>}
            <button
              type="submit"
              disabled={loading}
              className="inline-flex h-11 items-center justify-center rounded-lg bg-blue-600 px-6 font-semibold text-white shadow hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-70"
            >
              {loading ? "Отправляем..." : "Отправить ссылку"}
            </button>
          </form>
        </section>
      </div>
    </div>
  );
}
